<template>
	<div class="page-user-lsit">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">權限管理</div>
			<div class="breadcrumb-item">管理員列表</div>
		</div>
		
		<div class="card-block">
			<Form inline class="pg-form-inline form-input-wrap">
				<FormItem>
					<label class="input-label">用戶名稱</label>
					<Input size="small" v-model="form.username" clearable @keyup.enter.native="handleSearch()"/>
				</FormItem>
				<FormItem>
					<label class="input-label">手機號碼</label>
					<Input size="small" v-model="form.phone" clearable @keyup.enter.native="handleSearch()"/>
				</FormItem>
				<FormItem>
					<div class="pg-btn-wrap">
						<div class="pg-btn style1" @click="handleSearch">搜索</div>
						<!-- <div class="pg-btn style2">導出excel</div> -->
					</div>
				</FormItem>
			</Form>
		</div>
		
		<div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
				<Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
				<div class="loading-text">Loading</div>
			</Spin>
			<div class="pg-toolbar">
				<div class="pg-btn-wrap">
					<div class="pg-btn style1" @click="handleToAdd">新增管理員</div>
				</div>
			</div>
			
			<el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
				<el-tab-pane v-for="(item, index) in samecityList" :name="String(item.id)" :key="item.id"
				             :label="item.name"></el-tab-pane>
				<Table size="small"
				       no-data-text="暫無數據"
				       border
				       :columns="table.column"
				       :data="table.data">
					<template slot-scope="{ row, index }" slot="avatar">
						<div class="avatar-box">
							<img :src="row.avatar" alt="">
						</div>
					</template>
					<template slot-scope="{ row, index }" slot="action">
						<div class="pg-btn-wrap">
							<div class="pg-btn style3" @click="handleRole(index)">分派權限</div>
							<div class="pg-btn style2" @click="handleEdit(index)">修改</div>
							<div class="pg-btn style1" @click="handleDelete(index)">删除</div>
						</div>
					</template>
					<template slot-scope="{ row, index }" slot="retreat">
						<div class="pg-btn-wrap">
							<div v-if="row.retreat == 1">澳門</div>
							<div v-else>内地</div>
						</div>
					</template>
				</Table>
				
				<div class="pg-pagger">
					<Row>
						<Col span="12" class="pagger-left">
							<div class="pagger-total">總共{{ totalCount }}條記錄</div>
						</Col>
						<Col span="12" class="pagger-right">
							<!-- v-if="totalCount > curPageSize" -->
							<div>
								<div class="pagger-sizer">
									<span>每頁</span>
									<Select v-model="curPageSize" size="small" placeholder="數量"
									        @on-change="handlePageSizeChange">
										<Option :value="10">10</Option>
										<Option :value="20">20</Option>
										<Option :value="30">30</Option>
										<Option :value="40">40</Option>
										<Option :value="50">50</Option>
									</Select>
								</div>
								
								<div class="pagger-elevator">
									<span>跳轉</span>
									<Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
									       @on-enter="handlePageEnter"/>
								</div>
								
								<Page size="small"
								      :current="pageIndex"
								      :page-size="curPageSize"
								      :total="totalCount"
								      @on-change="handlePageChange">
								</Page>
							</div>
						</Col>
					</Row>
				</div>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeName: "1",
			company_name: 1,
			samecityList: [],
			pageIndex: 1,   //页码
			curPageSize: 10,    //一页数量
			totalCount: 1, //总条数
			pageInput: '',  //输入的页码
			isSubmiting: false,
			form: {
				username: '',
				phone: ''
			},
			table: {
				column: [
					{
						title: '公司',
						key: 'userparent',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '用戶名稱',
						key: 'username',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '姓名',
						key: 'realname',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '電話號碼',
						key: 'phone',
						align: 'center',
						sortable: true,
						minWidth: 100
					},{
						title: '歸屬地',
						key: 'retreat',
						slot: 'retreat',
						align: 'center',
						sortable: true,
						minWidth: 100
					},
					{
						title: '創建時間',
						key: 'ctime',
						align: 'center',
						sortable: true,
						minWidth: 50
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						minWidth: 120
					}
				],
				data: []
			}
		};
	},
	mounted() {
		this.getSamcityList();
		this.getList(this.company_name);
	},
	activated() {
		this.getSamcityList();
		this.getList(this.company_name);
	},
	methods: {
		handleClick(tab, event) {
			this.getList(tab.name, 1, 10);
		},
		getSamcityList() {
			this.$Rq.requestAuth({
				url: this.$Api.samecityUserList,
				method: 'get',
			}).then((res) => {
				if (res.code == 0) {
					this.samecityList = res.data.data;
				}
			});
		},
		getList(companyid, offset, limit) {
			if (limit != undefined) {
				this.curPageSize = limit;
			}
			if (offset != undefined) {
				this.pageIndex = offset;
			}
			if (companyid != undefined) {
				this.company_name = companyid;
			} else {
				this.company_name = 1;
			}
			let form = this.form;
			this.isSubmiting = true;
			this.$Rq.requestAuth({
				url: this.$Api.adminList,
				method: 'get',
				data: {
					parent_id: this.company_name,
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
					username: form.username,
					phone: form.phone
				}
			}).then((res) => {
				this.isSubmiting = false;
				if (res.code == 0) {
					let tempArr = [];
					let resData = res.data.data;
					for (let i = 0; i < resData.length; i++) {
						tempArr.push({
							user_id: resData[i].user_id,
							username: resData[i].username,
							phone: resData[i].phone == null ? '- - -' : resData[i].phone,
							realname: resData[i].realname,
							userparent: resData[i].userparent == null ? '- - -' : resData[i].userparent.name,
							ctime: resData[i].ctime,
							retreat: resData[i].retreat,
						});
					}
					this.totalCount = res.data.count;
					this.table.data = tempArr;
				} else {
					this.showTipInfo(res.msg);
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		handleDelete(index) {
			this.$Modal.confirm({
				title: '提示',
				content: '確定刪除嗎？',
				cancelText: '取消',
				okText: '確定',
				onOk: () => {
					let tableData = this.table.data;
					this.isSubmiting = true;
					this.$Rq.requestAuth({
						url: this.$Api.adminDelete + '/' + tableData[index].user_id,
						method: 'post',
					}).then((res) => {
						this.isSubmiting = false;
						if (res.code == 0) {
							this.$Utils.showSuccess(res.msg);
							this.pageIndex = 1;
							this.getList(this.company_name);
						} else {
							this.$Utils.showTipInfo(res.msg);
						}
					}).catch((err) => {
						this.isSubmiting = false;
					});
				}
			});
		},
		handleToAdd() {
			this.$router.push({path: '/adminAdd'});
		},
		handleSearch() {
			this.pageIndex = 1;
			this.getList(this.company_name);
		},
		handleEdit(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/adminEdit?id=' + tableData[index].user_id});
		},
		handleRole(index) {
			let tableData = this.table.data;
			this.$router.push({path: '/adminRole?id=' + tableData[index].user_id});
		},
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList(this.company_name);
		},
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList(this.company_name);
		},
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList(this.company_name);
		}
	}
};
</script>

<style lang="scss" scoped>
@import 'AdminList';
</style>
